/* Global LP scripts — loaded on request.page_type == 'page' (see layout/theme.liquid).
   Add future site-wide LP behaviors here. */
(function () {
  if (window.__lpBaseInit) return;
  window.__lpBaseInit = true;

  /* ---------------------------------------------------------------------------
     Copy to clipboard — event delegation on document.
     Markup: <b class="lp-copy" data-copy="MUSCLE20" data-tip="Copy to clipboard">MUSCLE20</b>
       data-copy        text to copy (falls back to element textContent)
       data-tip         tooltip text (optional; no tooltip if absent)
       data-tip-copied  tooltip text after copy (optional; default "Copied!")
  --------------------------------------------------------------------------- */

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { fallbackCopy(text); });
    }
    fallbackCopy(text);
    return Promise.resolve();
  }

  function runCopy(el) {
    var text = el.getAttribute('data-copy') || el.textContent.trim();
    copyText(text).then(function () {
      if (el.hasAttribute('data-tip')) {
        if (!el.dataset.tipDefault) el.dataset.tipDefault = el.getAttribute('data-tip');
        el.setAttribute('data-tip', el.getAttribute('data-tip-copied') || 'Copied!');
        el.classList.add('is-copied');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el) runCopy(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el) { e.preventDefault(); runCopy(el); }
  });

  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el && el.dataset.tipDefault) {
      el.setAttribute('data-tip', el.dataset.tipDefault);
      el.classList.remove('is-copied');
    }
  });

  document.addEventListener('focusout', function (e) {
    var el = e.target.closest && e.target.closest('.lp-copy');
    if (el && el.dataset.tipDefault) {
      el.setAttribute('data-tip', el.dataset.tipDefault);
      el.classList.remove('is-copied');
    }
  });

  /* a11y: make .lp-copy keyboard-focusable / announced as button */
  function enhance() {
    document.querySelectorAll('.lp-copy').forEach(function (el) {
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  /* ---------------------------------------------------------------------------
     Theme-independent section anchors.
     Section ids embed the template id, which differs per theme copy:
       #shopify-section-template--25623336550673__lp_bsh_columns_K36qBm
     so links saved in one theme break in a duplicate / GitHub-connected theme.
     Here every "#…template--<digits>__<key>" link (and a bare "#<key>") is
     re-pointed to the element on this page with the same prefix + section key.
     Runs before lp-anchor-nav.js (this file loads earlier with defer).
  --------------------------------------------------------------------------- */

  var ANCHOR_RE = /^(.*?)template--\d+__(.+)$/;

  function findAnchor(id) {
    if (!id) return null;
    var el = document.getElementById(id);
    if (el) return el;

    var m = id.match(ANCHOR_RE);
    if (m) {
      return document.querySelector('[id^="' + m[1] + 'template--"][id$="__' + m[2] + '"]');
    }
    /* bare section key, e.g. #lp_bsh_columns_K36qBm */
    return document.querySelector('[id^="shopify-section-"][id$="__' + id + '"]');
  }

  function fixAnchorLinks(scope) {
    (scope || document).querySelectorAll('a[href*="#"]').forEach(function (link) {
      var href = link.getAttribute('href');
      var i = href.indexOf('#');
      var id = href.slice(i + 1);
      if (!id || /["\\\]]/.test(id)) return;

      /* only same-page links: "#…" or a path equal to the current one */
      var path = href.slice(0, i);
      if (path && path.split('?')[0] !== window.location.pathname) return;
      if (document.getElementById(id)) return;

      var target = findAnchor(id);
      if (target) link.setAttribute('href', '#' + target.id);
    });
  }

  function fixLocationHash() {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id || document.getElementById(id) || /["\\\]]/.test(id)) return;
    var target = findAnchor(id);
    if (!target) return;
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + target.id);
    }
    target.scrollIntoView();
  }

  function initAnchors() {
    fixAnchorLinks();
    if (window.location.hash) window.addEventListener('load', fixLocationHash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnchors);
  } else {
    initAnchors();
  }

  document.addEventListener('shopify:section:load', function () {
    fixAnchorLinks();
  });

  /* ---------------------------------------------------------------------------
     window.LpCart — open the side cart after anything was added (shared by the
     lp-atc links below and LP pricing snippets such as research-grade-pricing).

       LpCart.open({ discount: 'CODE', activeElement: el })  → Promise
         POST /cart/update.js { discount, sections, sections_url } and hand the
         result to <mini-cart>.renderContents() — the same call product-form.js
         makes — so the drawer opens already at the discounted price and the
         header cart bubbles refresh. Resolves true when the drawer opened.
         No drawer on the page, or the refresh fails → LpCart.goToCart() and
         the promise never settles (the page is navigating away).

       LpCart.goToCart('CODE')  → /discount/CODE?redirect=/cart, or /cart.
  --------------------------------------------------------------------------- */

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function goToCart(discount) {
    window.location.href = discount
      ? '/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent('/cart')
      : '/cart';
    return new Promise(function () {});
  }

  function openCartDrawer(opts) {
    opts = opts || {};
    var drawer = document.querySelector('mini-cart');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') {
      return goToCart(opts.discount);
    }
    var body = {
      sections: drawer.getSectionsToRender().map(function (s) { return s.section; }).join(','),
      sections_url: window.location.pathname
    };
    if (opts.discount) body.discount = opts.discount;
    return postJSON('/cart/update.js', body)
      .then(function (cart) {
        if (opts.activeElement && drawer.setActiveElement) drawer.setActiveElement(opts.activeElement);
        drawer.renderContents(cart);
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        /* pubsub.js declares these as top-level const/function, not window props. */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: opts.source || 'lp-cart', cartData: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return true;
      })
      .catch(function () {
        /* The item is already in the cart; the cart page will show it. */
        return goToCart(opts.discount);
      });
  }

  window.LpCart = { open: openCartDrawer, goToCart: goToCart };

  /* ---------------------------------------------------------------------------
     Add-to-cart links — any link, set up in a plain URL field:
       /products/<handle>?lp-atc=1[&discount=CODE][&variant=ID][&qty=N][&selling_plan=ID]
     Click → POST /cart/add.js (first available variant unless ?variant=; as a
     subscription when ?selling_plan= is set), then LpCart.open() with the code. Without JS, or if the add fails, the link still
     opens the product page, so the button never dead-ends.
  --------------------------------------------------------------------------- */

  function parseAtcLink(link) {
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.origin); } catch (e) { return null; }
    if (url.searchParams.get('lp-atc') !== '1') return null;
    var m = url.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    return {
      handle: m[1],
      variant: url.searchParams.get('variant'),
      qty: Math.max(1, parseInt(url.searchParams.get('qty'), 10) || 1),
      discount: url.searchParams.get('discount') || '',
      sellingPlan: url.searchParams.get('selling_plan'),
      fallback: url.pathname
    };
  }

  function resolveVariant(atc) {
    if (atc.variant) return Promise.resolve(atc.variant);
    return fetch('/products/' + atc.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        if (!v) throw new Error('sold out');
        return v.id;
      });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="lp-atc=1"]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var atc = parseAtcLink(link);
    if (!atc) return;
    e.preventDefault();
    if (link.classList.contains('is-loading')) return;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');

    resolveVariant(atc)
      .then(function (id) {
        var item = { id: Number(id), quantity: atc.qty };
        if (atc.sellingPlan) item.selling_plan = Number(atc.sellingPlan);
        return postJSON('/cart/add.js', { items: [item] });
      })
      .then(function () {
        return openCartDrawer({ discount: atc.discount, activeElement: link, source: 'lp-atc' }).then(function () {
          link.classList.remove('is-loading');
          link.removeAttribute('aria-busy');
        });
      }, function () {
        window.location.href = atc.fallback;
      });
  });
})();
